<template>
  <div class="hello">
    <div
      style="width: 40px; border-bottom: 3px solid #0faa9d; margin-bottom: 15px"
    ></div>
    <table class="">
      <tr>
        <td>
          <b>DAY 1</b>
        </td>
        <td>04:30 - 05:00</td>
        <td>Berkumpul di kampus Jogja</td>
      </tr>
      <tr>
        <td></td>
        <td>05.00 – 06.30</td>
        <td>Perjalanan ke Solo dengan bus</td>
      </tr>
      <tr>
        <td></td>
        <td>06.30 - 07.30</td>
        <td>Tiba di Airport Adisumarmo, check in & boarding</td>
      </tr>
      <tr>
        <td></td>
        <td>08.10 – 10.25</td>
        <td>Penerbangan ke Denpasar</td>
      </tr>
      <tr>
        <td></td>
        <td>10.25 – 11.00</td>
        <td>Landing di Ngurah Rai Airport Menuju Parkiran Bus</td>
      </tr>
      <tr>
        <td></td>
        <td>11.00 – 12.30</td>
        <td>Menuju restoran di Bedugul</td>
      </tr>
      <tr>
        <td></td>
        <td>12.30 – 13.15</td>
        <td>Makan siang & sholat di Saras Resto</td>
      </tr>
      <tr>
        <td></td>
        <td>13.30 – 14.30</td>
        <td>Wisata Pura Ulundanu</td>
      </tr>
      <tr>
        <td></td>
        <td>14.30 – 18.00</td>
        <td>Perjalanan & wisata Pura Uluwatu</td>
      </tr>
      <tr>
        <td></td>
        <td>18.00 – 19.00</td>
        <td>Menuju restoran sunset road</td>
      </tr>
      <tr>
        <td></td>
        <td>19.00 – 20.00</td>
        <td>Makan malam di Grafika Sunset</td>
      </tr>
      <tr>
        <td></td>
        <td>20.00 – 21.30</td>
        <td>Belanja oleh-oleh di Krisna</td>
      </tr>
      <tr>
        <td></td>
        <td>21.30 – 22.00</td>
        <td>Menuju hotel Check in & istirahat</td>
      </tr>
    </table>

    <div
      style="width: 40px; border-bottom: 3px solid #0faa9d; margin-bottom: 15px"
    ></div>
    <table class="">
      <tr>
        <td>
          <b>DAY 2</b>
        </td>
        <td>06.00 – 08.00</td>
        <td>Sarapan & prepare check out</td>
      </tr>
      <tr>
        <td></td>
        <td>08.00 - 10.30</td>
        <td>
          Meninggalkan hotel & menuju parkir bis dilanjutkan wisata ke Pantai
          Kuta ( ganti transport )
        </td>
      </tr>
      <tr>
        <td></td>
        <td>10.30 – 12.00</td>
        <td>Makan siang di grafika sunset</td>
      </tr>
      <tr>
        <td></td>
        <td>12.00 – 13.30</td>
        <td>Menuju Bandara Ngurah Rai *( singgah Joger )</td>
      </tr>
      <tr>
        <td></td>
        <td>14.00 – 15.30</td>
        <td>Check in & boarding Di Ngurah Rai Airport</td>
      </tr>
      <tr>
        <td></td>
        <td>15.55 – 16.00</td>
        <td>Penerbangan ke Solo</td>
      </tr>
      <tr>
        <td></td>
        <td>16.00 – 16.30</td>
        <td>Tiba di Solo di jemput oleh Bus</td>
      </tr>
      <tr>
        <td></td>
        <td>16.30 – 18.00</td>
        <td>
          Perjalanan ke kampus, wisata selesai dan semoga semua berbahagia
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Jogja",
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table td span {
  border-top: 3px solid #0faa9d;
}
table td {
  font-size: 14px;
  vertical-align: top;
  padding-bottom: 10px;
}
table td:nth-child(1) {
  width: 50px;
}
table td:nth-child(2) {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Jogja.vue